
import { Component, Vue } from "vue-property-decorator";
interface ICurrentCalendar {
  dateTitle: string;
  dateStart: number;
  dateArr: Date[];
}
@Component
export default class TestPicker extends Vue {
  weekNames: string[] = ["일", "월", "화", "수", "목", "금", "토"];
  todayDate: Date = new Date();
  startDate: Date = new Date("2023/1/12");
  endDate: Date = new Date("2026/12/11");
  rangeDate: Date[] = [];
  currentCalendar: ICurrentCalendar[] = [];

  mounted(): void {
    this.init();
  }

  private init() {
    this.initCalendar();
  }

  private initCalendar() {
    const startDate = this.startDate; // 현재 날짜가 검사 시작 날짜를 넘지 못했을 경우 : 현재 날짜가 검사 시작 날짜를 넘었을경우
    const endDate = this.endDate; // 검사 마지막 날짜
    const diffDate = (endDate.getTime() - startDate.getTime()) / 1000; // 두 달의 차이 값
    const monthCount = Math.round(diffDate / (60 * 60 * 24 * 30)); // 남은 개월수
    const tempArr = new Array(monthCount + 1).fill({}); // 개월 수 만큼 배열 공간 만들기

    this.currentCalendar = tempArr.map((_, idx) => {
      const selectDate = new Date(
        startDate.getFullYear(),
        startDate.getMonth() + idx
      ); // 선택된 날짜의 연도와 달 구하기
      const dateTitle = `${selectDate.getFullYear()}년 ${
        selectDate.getMonth() + 1
      }월`; // 선택된 날짜의 연도와 달 구하기
      const dateArrFill = new Array(
        new Date(
          selectDate.getFullYear(),
          selectDate.getMonth() + 1,
          0
        ).getDate()
      ).fill(" "); // 선택된 달의 말일 구하기
      const dateArr = dateArrFill.map((_, idx) => {
        return new Date(
          selectDate.getFullYear(),
          selectDate.getMonth(),
          idx + 1
        ); // 일자별로 배열에 담기
      });
      const dateStart = selectDate.getDay(); // 달의 시작 날짜 알아오기;
      const tamp: ICurrentCalendar = {
        dateTitle,
        dateStart,
        dateArr,
      };
      return tamp;
    });
    console.log(this.currentCalendar);
  }
  // public isToday(year: number, month: number, day: number) {
  //   let date = new Date();
  //   return (
  //     year == date.getFullYear() &&
  //     month == date.getMonth() + 1 &&
  //     day == date.getDate()
  //   );
  // }
  public onHandleRangeDate(date: Date) {
    // console.log(date, this.rangeDate[0], date > this.rangeDate);
    if (date < this.rangeDate[0]) {
      this.rangeDate = [];
    }
    if (this.rangeDate.length >= 2) {
      this.rangeDate = [];
    }
    const select = date;
    const selectArr = [...this.rangeDate, select].sort((a, b) => {
      if (a > b) {
        return 1;
      } else {
        return -1;
      }
    });
    this.rangeDate = [...selectArr];
    console.log(this.rangeDate);
  }
  public checkDate(date: Date) {
    const yseterDate = new Date().setDate(this.todayDate.getDate() - 1);
    return (
      date >= this.startDate &&
      date <= this.endDate &&
      date.getDay() !== 0 &&
      date.getTime() >= yseterDate
    );
  }
  public rangeActiveDate(date: Date) {
    return date >= this.rangeDate[0] && date <= this.rangeDate[1];
  }
  public rangeSelectDate(date: Date) {
    return this.rangeDate.includes(date);
  }
  public rangePositionDate(date: Date) {
    let className = "";
    if (date === this.rangeDate[0]) {
      className += "data-first ";
    }
    if (date === this.rangeDate[1]) {
      className += "data-last ";
    }
    return className;
  }
}

// export default {
//   data() {
//     return {
//       weekNames: ["일", "월", "화", "수", "목", "금", "토"],
//       todayDate: new Date(),
//       startDate: new Date("2023/1/12"),
//       endDate: new Date("2023/03/11"),
//       rangeDate: [],
//       currentCalendar: [],
//     };
//   },
//   mounted() {
//     this.init();
//   },
//   methods: {
//     init: function () {
//       this.initCalendar();
//     },
//     initCalendar: function () {
//       const startDate = this.startDate; // 현재 날짜가 검사 시작 날짜를 넘지 못했을 경우 : 현재 날짜가 검사 시작 날짜를 넘었을경우
//       const endDate = this.endDate; // 검사 마지막 날짜
//       const diffDate = (endDate - startDate) / 1000; // 두 달의 차이 값
//       const monthCount = Math.round(diffDate / (60 * 60 * 24 * 30)); // 남은 개월수
//       const tempArr = new Array(monthCount + 1).fill({}); // 개월 수 만큼 배열 공간 만들기

//       this.currentCalendar = tempArr.map((_, idx) => {
//         const selectDate = new Date(
//           startDate.getFullYear(),
//           startDate.getMonth() + idx
//         ); // 선택된 날짜의 연도와 달 구하기
//         const dateTitle = `${selectDate.getFullYear()}년 ${
//           selectDate.getMonth() + 1
//         }월`; // 선택된 날짜의 연도와 달 구하기
//         const dateArrFill = new Array(
//           new Date(
//             selectDate.getFullYear(),
//             selectDate.getMonth() + 1,
//             0
//           ).getDate()
//         ).fill(" "); // 선택된 달의 말일 구하기
//         const dateArr = dateArrFill.map((_, idx) => {
//           return new Date(
//             selectDate.getFullYear(),
//             selectDate.getMonth(),
//             idx + 1
//           ); // 일자별로 배열에 담기
//         });
//         const dateStart = selectDate.getDay(); // 달의 시작 날짜 알아오기;
//         const tamp = {
//           dateTitle,
//           dateStart,
//           dateArr,
//         };
//         return tamp;
//       });
//       console.log(this.currentCalendar);
//     },
//     isToday(year: number, month: number, day: number) {
//       let date = new Date();
//       return (
//         year == date.getFullYear() &&
//         month == date.getMonth() + 1 &&
//         day == date.getDate()
//       );
//     },
//     onHandleRangeDate(date) {
//       // console.log(date, this.rangeDate[0], date > this.rangeDate);
//       if (date < this.rangeDate[0]) {
//         this.rangeDate = [];
//       }
//       if (this.rangeDate.length >= 2) {
//         this.rangeDate = [];
//       }
//       const select = date;
//       const selectArr = [...this.rangeDate, select].sort((a, b) => {
//         if (a > b) {
//           return 1;
//         } else {
//           return -1;
//         }
//       });
//       this.rangeDate = [...selectArr];
//       console.log(this.rangeDate);
//     },
//     checkDate(date) {
//       const yseterDate = new Date().setDate(this.todayDate.getDate() - 1);
//       return (
//         date >= this.startDate &&
//         date <= this.endDate &&
//         date.getDay() !== 0 &&
//         date >= yseterDate
//       );
//     },
//     rangeActiveDate(date) {
//       return date >= this.rangeDate[0] && date <= this.rangeDate[1];
//     },
//     rangeSelectDate(date) {
//       return this.rangeDate.includes(date);
//     },
//     rangePositionDate(date) {
//       let className = "";
//       if (date === this.rangeDate[0]) {
//         className += "data-first ";
//       }
//       if (date === this.rangeDate[1]) {
//         className += "data-last ";
//       }
//       return className;
//     },
//   },
// };
